import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {UserDb} from './userDbSchema';
import {User, userSchema} from './userSchema';

/**
 * Convert user db to user type
 * @param db UserDb
 * @returns User
 */
export function mapUserDbToType(db: FirestoreDocSnapshotWithIdAndData<UserDb>): User {
  const data = mapFirestoreDocWithTimestamp(db);
  return userSchema.parse(data);
}
